import Image from "next/image";
import { LomdaScene, SceneTemplateVariation } from "@/lib/utils/lomda/types";
import {
    DEFAULT_LOMDA_TEMPLATE,
    SCENE_TEMPLATES,
} from "@/lib/utils/lomda/constants";
import LomdaEditorAvatar from "./templates/lomdaEditorAvatar";
import LomdaEditorForeground from "./templates/lomdaEditorForeground";
import SceneSlideFrame from "./templates/sceneSlideFrame";
import { cn } from "@/lib/utils";
import { t } from "@/lib/localization";

interface LomdaSceneLayoutProps {
    scene: LomdaScene;
    templateOverride?: SceneTemplateVariation;
    logoUrl?: string;
    thumbnail?: boolean;
    className?: string;
}
export default function LomdaSceneLayout({
    scene,
    templateOverride,
    logoUrl = "",
    thumbnail = false,
    className,
}: LomdaSceneLayoutProps) {
    const templateVariation: SceneTemplateVariation =
        templateOverride ?? scene?.template ?? DEFAULT_LOMDA_TEMPLATE;
    const templateConfig = SCENE_TEMPLATES[templateVariation];
    const brandingConfig = templateConfig.branding;
    const foregroundConfig = brandingConfig.foreground;
    const avatarConfig = templateConfig.avatar;

    return (
        <div
            className={cn(
                "absolute left-0 right-0 top-0 bottom-0 max-h-full w-auto max-w-full aspect-video m-auto overflow-hidden border",
                className
            )}
            style={{
                backgroundColor:
                    brandingConfig.background !== "none"
                        ? scene.colors[brandingConfig.background]
                        : "transparent",
            }}
        >
            {foregroundConfig && (
                <LomdaEditorForeground
                    foreground={foregroundConfig}
                    backgroundColor={
                        foregroundConfig.color !== "none"
                            ? (scene.colors[foregroundConfig.color] ??
                                  "transparent")
                            : "transparent"
                    }
                >
                    {avatarConfig && avatarConfig.nested && (
                        <LomdaEditorAvatar templateConfig={templateConfig} />
                    )}
                </LomdaEditorForeground>
            )}

            {avatarConfig && !avatarConfig.nested && (
                <LomdaEditorAvatar templateConfig={templateConfig} />
            )}

            <SceneSlideFrame
                templateOverride={templateOverride}
                templateConfig={templateConfig}
                sceneImage={scene.imageUrl}
                thumbnail={thumbnail}
            />

            {logoUrl && (
                <div
                    className="absolute h-auto"
                    style={{
                        top: "4.63%",
                        left: "2.6%",
                        width: "6.66%",
                        height: "7%",
                    }}
                >
                    <Image
                        src={logoUrl}
                        alt={t("ui.logo")}
                        fill
                        className="object-contain object-left-top w-full h-full"
                    />
                </div>
            )}
        </div>
    );
}
